import * as yup from 'yup';
import { isMediaObject } from '../../utils';

export const basicMapSchema = yup.object({
  mapImage: yup.mixed()
    .test('is-media-object', 'must be valid media', value => isMediaObject(value))
    .required('mapImage is required'),
  mapBackgroundColor: yup.string().required('Description is required'),
});
